import React from "react";
import { X, RotateCcw } from "lucide-react";
import ModelsSetupPanel from "./ModelsSetupPanel";
import YoutubeToolSetup from "./YoutubeToolSetup";
import DeepResearchPanel from "./DeepResearchPanel";

const RightPanel = ({
  isExpanded,
  onToggle,
  activePanel = "models", // 'models' | 'youtube' | 'research'
  onPanelChange,
  // Model settings props
  temperature,
  topP,
  instructions,
  outputLength,
  onTemperatureChange,
  onTopPChange,
  onInstructionsChange,
  onOutputLengthChange,
  onModelReset,
  // YouTube tool props
  onTranscribe,
  onSummarize,
  isProcessing,
  // YouTube settings props
  youtubeActiveTab,
  youtubeSummaryType,
  youtubeLanguage,
  youtubeTone,
  onYoutubeActiveTabChange,
  onYoutubeSummaryTypeChange,
  onYoutubeLanguageChange,
  onYoutubeToneChange,
  // Deep Research props
  onResearch,
  isResearchProcessing,
  researchMode,
  citationStyle,
  includeWebSources,
  includeDocSources,
  includeAIReasoning,
  onResearchModeChange,
  onCitationStyleChange,
  onIncludeWebSourcesChange,
  onIncludeDocSourcesChange,
  onIncludeAIReasoningChange,
  references,
  researchThreads,
  promptHistory,
  customNotes,
  onSaveReference,
  onSaveThread,
  onRerunPrompt,
  onSaveNote,
}) => {
  const handleClose = () => {
    onToggle(false);
  };

  return (
    <div
      className={`${
        isExpanded ? "w-[85vw] sm:w-80" : "w-0"
      } fixed md:relative right-0 top-0 h-full z-50 md:z-auto bg-bg-50 flex flex-col transition-all duration-300 ease-in-out overflow-hidden ${
        isExpanded ? "translate-x-0" : "translate-x-full md:translate-x-0"
      }`}
    >
      {isExpanded && (
        <>
          {/* Header with close and reset buttons */}
          <div className="flex items-center justify-between px-4 py-3 pt-[30px]">
            <span className="text-sm font-medium text-fg-50">
              {activePanel === "models"
                ? "Model Settings"
                : activePanel === "youtube"
                ? "YouTube Tool"
                : "Deep Research"}
            </span>
            <div className="flex items-center gap-1">
              {activePanel === "models" && (
                <button
                  onClick={onModelReset}
                  className="p-1 text-fg-60 hover:text-fg-50 transition-colors"
                  title="Reset to defaults"
                >
                  <RotateCcw size={16} />
                </button>
              )}
              <button
                onClick={handleClose}
                className="p-1 text-fg-60 hover:text-fg-50 transition-colors"
                title="Close panel"
              >
                <X size={18} />
              </button>
            </div>
          </div>

          {/* Panel Content */}
          <div className="flex-1 overflow-hidden">
            {activePanel === "models" && (
              <ModelsSetupPanel
                temperature={temperature}
                topP={topP}
                instructions={instructions}
                outputLength={outputLength}
                onTemperatureChange={onTemperatureChange}
                onTopPChange={onTopPChange}
                onInstructionsChange={onInstructionsChange}
                onOutputLengthChange={onOutputLengthChange}
                onReset={onModelReset}
              />
            )}
            {activePanel === "youtube" && (
              <YoutubeToolSetup
                onTranscribe={onTranscribe}
                onSummarize={onSummarize}
                isProcessing={isProcessing}
                activeTab={youtubeActiveTab}
                summaryType={youtubeSummaryType}
                language={youtubeLanguage}
                tone={youtubeTone}
                onActiveTabChange={onYoutubeActiveTabChange}
                onSummaryTypeChange={onYoutubeSummaryTypeChange}
                onLanguageChange={onYoutubeLanguageChange}
                onToneChange={onYoutubeToneChange}
              />
            )}
            {activePanel === "research" && (
              <DeepResearchPanel
                onResearch={onResearch}
                isProcessing={isResearchProcessing}
                researchMode={researchMode}
                citationStyle={citationStyle}
                includeWebSources={includeWebSources}
                includeDocSources={includeDocSources}
                includeAIReasoning={includeAIReasoning}
                onResearchModeChange={onResearchModeChange}
                onCitationStyleChange={onCitationStyleChange}
                onIncludeWebSourcesChange={onIncludeWebSourcesChange}
                onIncludeDocSourcesChange={onIncludeDocSourcesChange}
                onIncludeAIReasoningChange={onIncludeAIReasoningChange}
                references={references}
                researchThreads={researchThreads}
                promptHistory={promptHistory}
                customNotes={customNotes}
                onSaveReference={onSaveReference}
                onSaveThread={onSaveThread}
                onRerunPrompt={onRerunPrompt}
                onSaveNote={onSaveNote}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default RightPanel;
